app.service('price', function () {

	function format(price, currency = true) {
		let p = price.toString().split('.');
		let result = p[0];
		if (p[0].length > 3) {
			result = p[0].substr(0, p[0].length - 3) + ' ' + p[0].substr(p[0].length - 3, 3);
		}
		if (p[1]) {
			if (p[1].length == 1) {
				result += ',' + p[1] + '0';
			} else {
				result += ',' + p[1].substr(0, 2);
			}
		}
		result = result.replace(',00', '');
		return result + (currency ? ' zł' : '');
	}
	function number(price = '') {
		let value = price.toString().replace(/ /g, '').replace(/,/g, '.').replace(/[^0-9.]/g, '');
		if (value.indexOf(',') > -1) {
			value = value.substr(0, value.indexOf(',') + 2);
		}
		return parseInt(100 * value) / 100;
	}

	function add(a, b) {
		return Math.round(Math.round(100 * a) + Math.round(100 * b)) / 100;
	}
	function minus(a, b) {
		return Math.round(Math.round(100 * a) - Math.round(100 * b)) / 100;
	}

	return {
		format,
		number,
		add,
		minus
	}
});
